import PropTypes from 'prop-types'
import React from 'react'
import * as R from 'ramda'

import { formatDateTime } from '../../utils/index'
import { getPrice } from '../../utils/run/index'
import { PeopleAlsoAsk } from '../PeopleAlsoAsk/index'

export const RaceDetail = ({ addons, race, racesDetail }) => (
  <React.Fragment>
    <div className="ui segment">
      <h1 className="ui header">{race.title}</h1>
      <div className="ui divider" />
      <div className="ui sub header">
        <h3>วันเปิดรับสมัคร</h3>
      </div>
      <p>
        {formatDateTime(race.start_register_time)} -{' '}
        {formatDateTime(race.end_register_time)} (หรือจนกว่าจะเต็มจำนวน)
      </p>
      <div className="ui sub header">
        <h3>วันแข่งขัน</h3>
      </div>
      <p>
        {formatDateTime(race.start_time)} - {formatDateTime(race.end_time)}
      </p>
      <div className="ui sub header">
        <h3>วันเเจ้งส่งผลการวิ่ง/เดิน</h3>
      </div>
      <p>
        {formatDateTime(race.start_time)} -{' '}
        {formatDateTime(race.last_submit_time)}
      </p>
      <div className="ui sub header">
        <h3>ประเภทของกิจกรรม</h3>
      </div>
      <p>
        {race.is_walk
          ? 'เดินเก็บระยะก้าว'
          : race.collect_distance
          ? 'วิ่งแบบสะสมระยะ'
          : 'วิ่งแบบครั้งเดียวจบ'}
      </p>
      <div className="ui sub header">
        <h3>สถานที่</h3>
      </div>
      <p>
        งานนี้เป็น Virtual Run คุณสามารถวิ่งที่ไหน เมื่อไรก็ได้ ไม่จำกัดเวลา
        ไม่จำกัดสถานที่
      </p>
      <div className="ui sub header">
        <h3>ราคา</h3>
      </div>
      <p>{getPrice(racesDetail)} ฿</p>
      <div className="ui sub header">
        <h3>ระยะการวิ่ง</h3>
      </div>
      <p>
        {race.id === 20 && '30 KM'}
        {race.id !== 20 &&
          racesDetail.map((detail, index) =>
            index === racesDetail.length - 1
              ? detail.distance.name
              : `${detail.distance.name}, `
          )}
      </p>
      <div className="ui sub header">
        <h3>วันสิ้นสุดกิจกรรม</h3>
      </div>
      <p>{formatDateTime(race.last_submit_time)}</p>
      <div className="ui sub header">
        <h3>ช่วงเวลาจัดส่งของที่ระลึก</h3>
      </div>
      <p>ภายใน 10 วันทำการ หลังสิ้นสุดกิจกรรม</p>
      <div className="ui divider" />
      <h3 className="ui header">About</h3>
      <div dangerouslySetInnerHTML={{ __html: race.description }} />
      <div className="ui divider" />
      {race.medal_description && (
        <React.Fragment>
          <h3 className="ui header">Medals</h3>
          <p>{race.medal_description}</p>
          <div className="ui divider" />
        </React.Fragment>
      )}
      <h3 className="ui header">จะเข้าร่วมงาน {race.title} ได้อย่างไร?</h3>
      <div className="ui bulleted list">
        <div className="item">
          กดปุ่มสมัครด้านขวามือ เลือกระยะการวิ่งและกรอกข้อมูลให้เรียบร้อย
        </div>
        <div className="item">
          จับเวลาและระยะทางด้วยลู่วิ่ง นาฬิกาหรือ Application บนมือถือ
        </div>
        <div className="item">
          บันทึกรูประยะวิ่งและส่งผลการวิ่งทางหน้าเว็บไซต์
        </div>
        <div className="item">
          ทางเราจะตรวจสอบและส่งรางวัลไปยังที่อยู่ที่กรอกไว้
        </div>
      </div>
      <div className="ui divider" />
      <h3 className="ui header">กฎกติกา</h3>
      <div className="ui bulleted list">
        {race.is_walk ? (
          <div className="item">งานนี้เป็นการเดินแบบสะสมจำนวนก้าว</div>
        ) : race.collect_distance ? (
          <div className="item">การวิ่งนี้เป็นการวิ่งแบบสะสมระยะ</div>
        ) : (
          <div className="item">การวิ่งนี้เป็นการวิ่งครั้งเดียวจบ</div>
        )}
        <div className="item">
          สามารถส่งผลการวิ่ง/เดินได้ถึงวันที่{' '}
          {formatDateTime(race.last_submit_time)}
        </div>
        <div className="item">
          หากวิ่งไม่ครบตามระยะทางที่สมัครหรือไม่ได้ส่งผลวิ่ง /
          เดินภายในวันที่กำหนด ทางเราขอสงวนสิทธิ์ในการรับของรางวัล
        </div>
        <div className="item">
          ไม่สามารถเปลี่ยนแปลงระยะทางการวิ่ง ยกเลิกการวิ่ง
          หรือโอนสิทธิ์ให้ผู้อื่นได้
        </div>
        <div className="item">
          จับเวลาและระยะทางในการวิ่งเเล้วถ่ายรูปหน้าจอลู่วิ่ง รูปนาฬิกา
          หรือเซฟหน้าจอมือถือที่เเสดงระยะทางเเละเวลาในการวิ่ง
          จากแอปพลิเคชั่นในมือถือเช่น Nike+,Garmin,Fitbit,Endomondo,Apple Watch
          หรือแอปพลิเคชั่นอื่นๆ
        </div>
        <div className="item">
          แจ้งโอนเงินเเละส่งผลวิ่ง / เดินผ่านทางเวปไซส์เท่านั้น
          ไม่สามารถเเจ้งทาง Line หรือ Facebook Messenger ได้
        </div>
        <div className="item">ไม่สามารถคืนเงินทุกกรณี</div>
        <div className="item">
          บัญชีของคุณจะถูกระงับ หากพบว่ามีการส่งผลอย่างไม่ถูกต้อง
        </div>
      </div>
    </div>
    {!R.isEmpty(addons) && (
      <div className="ui segment">
        <h3 className="ui header">เสื้อวิ่ง {race.title}</h3>
        <div dangerouslySetInnerHTML={{ __html: race.addon_description }} />
        {race.addon_images
          .sort((a, b) => a.id - b.id)
          .map(image => (
            <img style={{ marginTop: '10px' }} src={image.image} />
          ))}
      </div>
    )}
    <div className="ui segment">
      <h1>คำถามที่พบบ่อย?</h1>
      <PeopleAlsoAsk />
    </div>
    {/* <div className="ui segment">
      <h1>Awards</h1>
    </div> */}
  </React.Fragment>
)

RaceDetail.propTypes = {
  addons: PropTypes.arrayOf(PropTypes.object),
  race: PropTypes.object,
  racesDetail: PropTypes.arrayOf(PropTypes.object)
}



// WEBPACK FOOTER //
// /opt/build/repo/src/components/RaceDetail/index.js